let moduleApi = {};

function getHeaders() {
  const token = localStorage.getItem(`mushroom.tokens[${window.MyConfig.hostApi}]`);
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Token': token
  };
}

function toDateTime(dateStr) {
  return `${dateStr}T00:00:00.000+07:00`;
}

function addOneDay(dateStr) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

moduleApi.list = async (dataFilter = {}) => {
  const params = new URLSearchParams();

  if (dataFilter.sort   !== undefined) params.set('$sort',    dataFilter.sort);
  if (dataFilter.limit  !== undefined) params.set('$limit',   dataFilter.limit);
  if (dataFilter.offset !== undefined) params.set('$offset',  dataFilter.offset);
  if (dataFilter.vn_text)              params.set('$vn_text', dataFilter.vn_text);

  if (dataFilter.company_id)    params.set('company_id',    dataFilter.company_id);
  if (dataFilter.change_source) params.set('change_source', dataFilter.change_source);

  // Range filters — operator là > / < nằm trong tên param, URLSearchParams tự encode
  if (dataFilter.changed_at_from)
    params.set('changed_at>',        toDateTime(dataFilter.changed_at_from));
  if (dataFilter.changed_at_to)
    params.set('changed_at<',        toDateTime(addOneDay(dataFilter.changed_at_to)));
  if (dataFilter.target_work_date_from)
    params.set('target_work_date>',  toDateTime(dataFilter.target_work_date_from));
  if (dataFilter.target_work_date_to)
    params.set('target_work_date<',  toDateTime(addOneDay(dataFilter.target_work_date_to)));

  const url = `${window.MyConfig.hostApi}work_change_historys/?${params.toString()}`;
  const response = await fetch(url, { method: 'GET', headers: getHeaders() });
  const result = await response.json();
  if (!response.ok || (result.code !== undefined && result.code < 0)) {
    throw result;
  }
  return result;
};

export default moduleApi;
